<template>
    <img loading="lazy" class="tx-icon" :src="computedSrc" :style="computedSize" @error="handleError" @load="handleSuccess" alt="">
</template>
<script setup>
const  props = defineProps({
    size: {
        type:Object,
        default:{
            width:80,
            height:80,
        }
    },
    team:{
        type:String,
        default:'tx2'
    },
    src:{
        type:String,
    }
})
const computedSize = computed(() => {
    if (props.size) {
        return {
            width: px2Vw(props.size.width) + 'vw',
            height: px2Vw(props.size.height) + 'vw'
        }
    } else {
        return {}
    }
})

const computedSrc = computed(() => {
    if (props.team=='txm') {
        return `https://g20.gsf.netease.com/20250417/txhead20250417/${props.src}`
    }else if(props.team='tx2'){
        return `https://g20.gsf.netease.com/h5/common/tx3/head/${props.src}`
    }
})
function px2Vw(px) {
    return parseFloat((px / 750) * 100)
}
</script>
<style scoped>
.tx-icon {
    border-radius: 50%;
}
</style>